import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type {
  NotificationChannel,
  NotificationEventKey,
} from "@colab/shared";

// GET /api/portal/preferences — returns the 32-cell matrix (16 event_keys × 2
// channels) with missing-row defaults already realized server-side. Phase 7
// sub-bucket 7. See apps/api/src/services/portal-preferences.ts.

export type NotificationPreferenceCell = {
  event_key: NotificationEventKey;
  channel: NotificationChannel;
  enabled: boolean;
};

export function useNotificationPreferences() {
  return useQuery<NotificationPreferenceCell[], ApiClientError>({
    queryKey: queryKeys.portal.preferences(),
    queryFn: () => apiFetch<NotificationPreferenceCell[]>("/portal/preferences"),
  });
}
